exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".visualtype-height {\n  height: 40vh;\n  max-height: 60vw;\n}\n.accordion-height {\n  height: 34px;\n  font-size: 0.875rem;\n}\n@media (min-width: 768px) {\n.visualtype-height {\n    height: 40vh;\n    max-height: 50vw;\n}\n.accordion-height {\n    font-size: 1.25rem;\n}\n}\n@media (min-width: 1024px) {\n.visualtype-height {\n    height: 70vh;\n    max-height: 40vw;\n}\n.accordion-height {\n    font-size: 1.25rem;\n}\n}", ""]);

// exports
